import { useMemo } from 'react';

// material-ui
import { Box, useMediaQuery } from '@mui/material';
// project import
import HeaderLogoIcon from "../../../../assets/images/icons/menu/headerLogoIcon";
import { Title } from "../../../../pages/main/common";
import AccountMenu from "../../../app/accountmenu/accountMenu";
import LanguageSelect from "../../../general/languageSelect/languageSelect";

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
	const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
	
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const localization = useMemo(() => <LanguageSelect/>, []);
	
	return (
		<>
			{!downSM && <Title/>}
			{!downSM && <Box sx={{ ml: 'auto' }}/>}
			{downSM &&
				<Box sx={{ marginRight: "auto", maxWidth: 160, ml: '16px', cursor: "pointer" }}>
					<HeaderLogoIcon/>
				</Box>
			}
			<Box sx={{ display: 'flex', gap: downSM ? '2px' : '32px' }}>
				{localization}
				<AccountMenu/>
			</Box>
		</>
	);
};

export default HeaderContent;
